'use strict';

var FlightDOWFilterFactory = function FlightDOWFilterFactory(DataFilter) {
  function FlightDOWFilter() {
    this.sourceType = ['cabin', 'cabin-da', 'cabin-post-departure', 'class'];
    this.filterType = 'dow';
  }
  FlightDOWFilter.constructor = FlightDOWFilter;
  FlightDOWFilter.prototype = Object.create(DataFilter.prototype);
  FlightDOWFilter.prototype.groupBy = 'departureDateDOW';
  return FlightDOWFilter;
};
FlightDOWFilterFactory.$inject = ['DataFilterFactory'];
module.exports = FlightDOWFilterFactory;